"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable complexity */
/* eslint-disable max-statements */
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const question_models_1 = require("src/types/question-models");
const questions_1 = require("src/types/questions");
const question_1 = require("src/utils/question");
function removeLetters(text, numberType = 'any') {
    if (numberType === 'int') {
        return removeLettersAndDots(text);
    }
    return (text
        .replace(/,/g, '.')
        // удаляю все кроме чисел и точек, а также все минусы, кроме того, что стоит первым знаком
        .replace(/[^0-9.-]|(?!^)-/g, '')
        // удаляю все точки кроме первой
        .replace(/^([^.]*\.)(.*)$/, (_, start, end) => start + end.replace(/\./g, ''))
        .substring(0, 16));
}
function removeLettersAndDots(text) {
    return (text
        // удаляю все кроме чисел, а также все минусы, кроме того, что стоит первым знаком
        .replace(/[^0-9-]|(?!^)-/g, '')
        .substring(0, 16));
}
function bringToNumberType(text, numberType = 'any') {
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
    return numberType === 'int' ? parseInt(text, 10) : parseFloat(text, 10);
}
const helper = (model, action) => {
    switch (action.type) {
        case 'QUESTION_CLICK_OPTION': {
            if (!(0, question_models_1.isQuestionWithOptionsModel)(model))
                break;
            model.setValue(action.value);
            break;
        }
        case 'QUESTION_TABLE_CLICK_OPTION': {
            if (!(0, question_models_1.isTableQuestionModel)(model))
                break;
            model.setValue(action.value);
            break;
        }
        case 'QUESTION_CHANGE_TEXT': {
            if (!(0, question_models_1.isTextQuestionModel)(model))
                break;
            const text = (0, question_models_1.isNumberQuestionModel)(model)
                ? removeLetters(action.text, model.state.numberType)
                : action.text;
            model.setValue(text);
            if ((action === null || action === void 0 ? void 0 : action.nextBtnBehavior) === 'disabledUntilValid' && !text) {
                model.hideError();
            }
            break;
        }
        case 'QUESTION_BLUR_TEXT': {
            if (!(0, question_models_1.isTextQuestionModel)(model))
                break;
            if ((0, question_models_1.isNumberQuestionModel)(model) && model.state.value) {
                const value = bringToNumberType(model.state.value, model.state.numberType);
                model.state.value =
                    Number.isNaN(value) || typeof value !== 'number' ? '' : value.toString();
            }
            if ((action === null || action === void 0 ? void 0 : action.nextBtnBehavior) === 'disabledUntilValid' && !action.text) {
                break;
            }
            model.validate();
            model.showError();
            break;
        }
        case 'QUESTION_CLICK_OTHER': {
            if (!(0, question_models_1.isModelWithOtherAnswerWithTextOption)(model))
                break;
            model.toggleOther();
            break;
        }
        case 'QUESTION_CLICK_OTHER_WITH_TEXT': {
            if (!(0, question_models_1.isModelWithOtherAnswerWithTextOption)(model))
                break;
            model.toggleOtherWithText();
            break;
        }
        case 'QUESTION_CHANGE_OTHER_WITH_TEXT': {
            if (!(0, question_models_1.isModelWithOtherAnswerWithTextOption)(model))
                break;
            model.setOtherWithTextValue(action.value);
            break;
        }
        case 'QUESTION_CLICK_NO_ANSWER': {
            if (!(0, question_models_1.isModelWithNoAnswerOption)(model))
                break;
            model.toggleNoAnswer();
            break;
        }
        case 'QUESTION_CLICK_NO_OPINION_ANSWER': {
            if (!(0, question_models_1.isModelWithNoOpinionAnswerOption)(model))
                break;
            model.toggleNoOpinionAnswer();
            break;
        }
        case 'QUESTION_CLICKMAP_IMAGE_CLICK': {
            if (!(0, question_models_1.isUXQuestionModel)(model))
                break;
            model.pushValue({
                event: action.value.isTarget ? 'click_target' : 'click',
                timestamp: Number(action.value.timestamp),
                coordinates: {
                    x: action.value.x,
                    y: action.value.y
                }
            });
            break;
        }
        case 'QUESTION_CLICKMAP_IMAGE_DRAW': {
            if (!(0, question_models_1.isUXQuestionModel)(model))
                break;
            model.pushValue({
                event: 'draw',
                timestamp: action.value.timestamp
            });
            break;
        }
        case 'QUESTION_VIDEO_END': {
            if (!(0, question_models_1.isClickMapVideoQuestionModel)(model))
                break;
            model.pushValue(action.value.clicks);
            break;
        }
        default:
    }
    return model.getState();
};
const questions = (state = {}, action) => {
    switch (action.type) {
        case 'QUESTION_CLICK_OPTION':
        case 'QUESTION_TABLE_CLICK_OPTION':
        case 'QUESTION_CHANGE_TEXT':
        case 'QUESTION_BLUR_TEXT':
        case 'QUESTION_CLICK_OTHER':
        case 'QUESTION_CLICK_OTHER_WITH_TEXT':
        case 'QUESTION_CHANGE_OTHER_WITH_TEXT':
        case 'QUESTION_CLICK_NO_ANSWER':
        case 'QUESTION_CLICK_NO_OPINION_ANSWER':
        case 'QUESTION_CLICKMAP_IMAGE_CLICK':
        case 'QUESTION_CLICKMAP_IMAGE_DRAW':
        case 'QUESTION_VIDEO_END': {
            const newState = (0, cloneDeep_1.default)(state);
            const questionIndex = action.questionIndex.toString();
            const model = (0, question_1.createQuestionModel)(newState, questionIndex, {
                charLimits: action.charLimits
            });
            const updatedQuestion = helper(model, action);
            newState[questionIndex] = updatedQuestion;
            return newState;
        }
        case 'QUESTIONS_SHOW_ERRORS': {
            const { questionsIndexes } = action;
            const newState = (0, cloneDeep_1.default)(state);
            questionsIndexes.forEach(questionIndex => {
                const question = newState[questionIndex];
                if (question.visible) {
                    question.errorVisible = true;
                }
            });
            return newState;
        }
        case 'SURVEY_SET_INITED':
        case 'SURVEY_LOADED_FROM_CONFIG': {
            const revision = action.data;
            const payloadQuestions = revision.questions;
            const questionStates = {};
            Object.keys(payloadQuestions).forEach(id => {
                const question = (0, question_1.createQuestionModel)(payloadQuestions, Number(id));
                question.normalize();
                questionStates[id] = question.getState();
                questionStates[id].visible = true;
            });
            return (0, cloneDeep_1.default)(questionStates);
        }
        case 'NODE_VISIBILITY_CHANGED': {
            const newState = (0, cloneDeep_1.default)(state);
            action.nodes.forEach(node => {
                switch (node.type) {
                    case 'question': {
                        const question = (0, question_1.createQuestionModel)(newState, node.id);
                        if (!node.state) {
                            question.resetValue();
                            question.hideError();
                        }
                        newState[node.id] = Object.assign(Object.assign({}, question.getState()), { visible: node.state });
                        break;
                    }
                    case 'option': {
                        const question = newState[node.questionId];
                        if ((0, questions_1.isQuestionWithOptions)(question)) {
                            const options = [...question.options];
                            options.forEach(option => {
                                if (option.id === node.id) {
                                    option.visible = node.state;
                                }
                            });
                            question.options = options;
                        }
                        break;
                    }
                    default:
                }
            });
            return newState;
        }
        default:
            return state;
    }
};
exports.default = questions;
